import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: "Helvetica-Neue"
  },
  palette: {
    primary: {
      main: "rgb(255, 0, 208)"
    },
    secondary: {
      main: "#19857b"
    },
    error: {
      main: "rgb(255, 0, 208)"
    },
    text: {
      primary: "#222",
      secondary: "#222" 
    },
    mode: "light"
  }
});


theme.typography.h5 = {
  fontSize: '1.1rem',
};


export default theme;
